module.exports = __webpack_public_path__ + "img/sankaku_41_red.98b6946a.png";